import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import {
  FOOTBALL_MARKET_INSTANT_BUY,
  FOOTBALL_PLAY_PRO_ONBOARDING_TUTORIAL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { UnlockPro } from 'components/commonGame/UnlockPro';

import background from './assets/background.jpg';

const Wrapper = styled(FullWidthContainer.NoPadding)`
  height: calc(
    var(--100vh) - 1 * var(--current-stack-height) - 1 *
      var(--bottom-bar-height-mobile)
  );
  overflow: auto;
  background: center / cover no-repeat url(${background});
  padding: 0 var(--intermediate-unit);

  @media ${tabletAndAbove} {
    padding: 0 var(--triple-unit);
  }
`;

const GoProPage = () => {
  const navigate = useNavigate();
  const { isIosApp } = useIsMobileApp();

  return (
    <Wrapper>
      <UnlockPro
        onChoosePro={levelValue => {
          if (!isIosApp) {
            navigate(
              `${FOOTBALL_PLAY_PRO_ONBOARDING_TUTORIAL}?rarity=${levelValue}`
            );
          } else {
            navigate(
              `${FOOTBALL_MARKET_INSTANT_BUY}?isOnboardingFlow=true&isNewNavigation=true&rarity=${levelValue}`
            );
          }
        }}
        goProMode
      />
    </Wrapper>
  );
};
export default GoProPage;
